import { Typography, ButtonGroup, Button } from "@mui/material";
import MoedaText from "../ui/inputs/moedaText";
import { isUndefined, map } from "lodash";
import InteiroText from "../ui/inputs/inteiroText";
import TabelaBase from "./tabelaBase";
import Ticker from "../ui/ticker";
import ExercicioDireito from "../../../models/exercicioDireito";
import { IconTrashX } from "@tabler/icons-react";

type Props = {
  exercicios: ExercicioDireito[] | undefined;
  onDelete?: (exercicio: ExercicioDireito) => void;
};

export default function TabelaExercicios({ exercicios, onDelete }: Props) {
  const header: {
    titulo: string;
    key: string;
    ordem: number;
    align: "left" | "center" | "right";
  }[] = [
    { titulo: "Direito", key: "direito", ordem: 1, align: "center" },
    { titulo: "Ativo", key: "ativo", ordem: 2, align: "center" },
    {
      titulo: "Data do Exercício",
      key: "exercicio",
      ordem: 3,
      align: "center",
    },
    { titulo: "Quantidade", key: "quantidade", ordem: 4, align: "right" },
    {
      titulo: "Preço Unitário",
      key: "precounitario",
      ordem: 5,
      align: "right",
    },
    { titulo: "", key: "acoes", ordem: 6, align: "right" },
  ];

  const rows = map(exercicios, (exercicio) => ({
    direito: celulaDireito(exercicio),
    ativo: celulaAtivo(exercicio),
    exercicio: celulaExercicio(exercicio),
    quantidade: celulaQuantidade(exercicio),
    precounitario: celulaPrecoUnitario(exercicio),
    acoes: celulaAcoes(exercicio),
  }));

  return <TabelaBase header={header} rows={rows} />;
  function celulaDireito(exercicio: ExercicioDireito): JSX.Element {
    return <Ticker codigoAtivo={exercicio.codigoAtivo} color="primary" />;
  }

  function celulaAtivo(exercicio: ExercicioDireito): JSX.Element {
    return <Ticker codigoAtivo={exercicio.codigoObjeto} color="secondary" />;
  }

  function celulaExercicio(exercicio: ExercicioDireito): JSX.Element {
    return (
      <Typography variant="dataMono">
        {exercicio.dataExercicio.format("DD/MM/YYYY")}
      </Typography>
    );
  }

  function celulaQuantidade(exercicio: ExercicioDireito): JSX.Element {
    return (
      <Typography variant="dataMono">
        <InteiroText
          value={exercicio.quantidade}
          displayType={"text"}
        ></InteiroText>
      </Typography>
    );
  }

  function celulaPrecoUnitario(exercicio: ExercicioDireito): JSX.Element {
    return (
      <Typography variant="dataMono">
        <MoedaText
          displayType={"text"}
          value={exercicio.precoUnitario}
        ></MoedaText>
      </Typography>
    );
  }

  function celulaAcoes(exercicio: ExercicioDireito): JSX.Element {
    return (
      <ButtonGroup size="small" variant="outlined">
        {!isUndefined(onDelete) && (
          <Button color="error" onClick={() => onDelete(exercicio)}>
            <IconTrashX size={16} />
          </Button>
        )}
      </ButtonGroup>
    );
  }
}
